import { render, staticRenderFns } from "./OneBanner.vue?vue&type=template&id=db25b950&scoped=true&"
import script from "./OneBanner.vue?vue&type=script&lang=js&"
export * from "./OneBanner.vue?vue&type=script&lang=js&"
import style0 from "./OneBanner.vue?vue&type=style&index=0&id=db25b950&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db25b950",
  null
  
)

export default component.exports